import Table from "../../../components/list/Table";
import { format, parseISO } from "date-fns";
import { Card, Row, Col } from "react-bootstrap";
import { useGetInvoiceListQuery } from "../../../features/card/cardApi";
import { IoCloudDownloadOutline } from "react-icons/io5";

const apiUrl = (import.meta.env.VITE_API_URL as string)?.replace(/\/$/, "") ?? "";

const columns = [
  {
    id: "invoice_id",
    header: "Invoice#",
    accessorKey: "invoice_id",
    size: "18%",
    cell: ({ row }: { row: { original: { invoice_id?: string } } }) => (
      <span
        className="font-monospace text-nowrap"
        style={{ fontSize: "0.875rem", fontWeight: 500 }}
        title={row.original.invoice_id}
      >
        {row.original.invoice_id || "—"}
      </span>
    ),
  },
  {
    id: "ref_id",
    header: "Ref#",
    accessorKey: "ref_id",
    size: "10%",
    cell: ({ row }: { row: { original: { ref_id?: string } } }) => (
      <span className="text-nowrap" style={{ fontSize: "0.875rem" }}>
        {row.original.ref_id || "—"}
      </span>
    ),
  },
  {
    id: "purpose",
    header: "Purpose",
    accessorKey: "purpose",
    size: "12%",
  },
  {
    id: "amount",
    header: "Amount",
    accessorKey: "amount",
    size: "8%",
  },
  {
    id: "PaymentMethod",
    header: "Payment Description",
    accessorKey: "note",
    size: "22%",
  },
  {
    id: "type",
    header: "Type",
    accessorKey: "transaction_type",
    size: "8%",
  },
  {
    id: "created_at",
    header: "Charged on",
    accessorKey: "created_at",
    size: "12%",
    cell: ({ row }: { row: { original: { created_at?: string } } }) => {
      if (!row.original.created_at) return "—";
      return format(parseISO(row.original.created_at), "dd MMM yyyy");
    },
  },
  {
    id: "download",
    header: "Invoice",
    accessorKey: "transaction_id",
    size: "6%",
    cell: ({ row }: { row: { original: { transaction_id?: string } } }) => {
      const transactionId = row.original.transaction_id;
      if (!transactionId) return null;
      const invoiceUrl = `${apiUrl}/order/getInvoice/${transactionId}`;

      return (
        <a
          href={invoiceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="text-decoration-none"
          style={{
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
          }}
          title="Download Invoice"
        >
          <IoCloudDownloadOutline size={20} className="text-primary" />
        </a>
      );
    },
  },
];

const Invoice = () => {
  const { data, isFetching } = useGetInvoiceListQuery({});

  return (
    <Row>
      <Col>
        <Card
          style={{
            border: "none",
            boxShadow: "none",
            borderLeft: "1px solid rgba(25, 34, 46, 0.08)",
            borderRadius: "0",
            backgroundColor: "transparent",
          }}
        >
          <Card.Body style={{ padding: 0, backgroundColor: "transparent" }}>
            <div
              className="sticky-filter-bar"
              style={{
                position: "sticky",
                top: "50px",
                zIndex: 100,
                height: "50px",
                marginBottom: 0,
                display: "flex",
                gap: "20px",
                padding: "10px 20px",
                lineHeight: "24px",
                borderBottom: "1px solid #eef0f2",
              }}
            />
            <Row>
              <Col className="m-1">
                <div className="table-wrapper">
                  <Table
                    columns={columns}
                    data={data?.data ?? []}
                    isFetching={isFetching}
                    isSearchable={true}
                    isSortable={true}
                    tableClass="table-fixed w-100"
                    theadClass="table-light rounded sticky-table-header"
                  />
                </div>
                {!isFetching && !data?.data?.length && (
                  <div
                    style={{
                      padding: "20px",
                      paddingTop: "0",
                      marginTop: "0",
                      background: "#ffffff",
                      borderTop: "1px solid #e9ecef",
                    }}
                  >
                    <p className="text-muted text-center italic">No Entry Found</p>
                  </div>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Invoice;
